module.exports = __webpack_public_path__ + "static/media/break_pad.19a0ebaf.svg";